import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c(VDataTable,{attrs:{"dense":"","headers":_vm.headers,"items":_vm.commissions,"items-per-page":-1,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.role",fn:function({ item }){return [_vm._v("\n      "+_vm._s(_vm._f("roleLabel")(item.role))+"\n    ")]}},{key:"item.commission",fn:function({ item }){return [_vm._v("\n      "+_vm._s(item.commission)+"%\n    ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }